import { useAppDispatch } from "store/hooks";
import { useSelector } from "react-redux";
import { selectReachabilityResult } from "modules/systemCheck/redux/selectors";
import { useEffect } from "react";
import { setReachabilityTestResult } from "modules/systemCheck/redux/systemCheckSlice";
import { isReachabilityTest } from "modules/systemCheck/components/typeGuards";
import { withTimeout } from "modules/systemCheck/utils/withTimeout";
import { Errors, trackError } from "modules/monitoring";
import { REACHABILITY_TESTS } from "modules/systemCheck/components/constants";
import { isThirdPartyReachable } from "modules/systemCheck/utils/isThirdPartyReachable";

export const REACHABILITY_TIMEOUT_PERIOD = 7 * 1000;

export const ReachabilityTest = () => {
  const dispatch = useAppDispatch();
  const reachabilityResult = useSelector(selectReachabilityResult);

  useEffect(() => {
    Object.entries(reachabilityResult).forEach(([reachabilityTest, result]) => {
      if (
        result.isDirty &&
        !result.isLoading &&
        isReachabilityTest(reachabilityTest)
      ) {
        dispatch(
          setReachabilityTestResult({
            reachabilityTest,
            result: { isSuccessful: null, isDirty: false, isLoading: true },
          }),
        );

        (async () => {
          try {
            const reachable = await Promise.all(
              REACHABILITY_TESTS[reachabilityTest].map((thirdPartyService) =>
                withTimeout(
                  () => isThirdPartyReachable(thirdPartyService),
                  REACHABILITY_TIMEOUT_PERIOD,
                ),
              ),
            );

            dispatch(
              setReachabilityTestResult({
                reachabilityTest,
                result: {
                  isLoading: false,
                  isSuccessful: reachable.every(
                    (thirdPartyReachable) => thirdPartyReachable,
                  ),
                  isDirty: false,
                },
              }),
            );
          } catch (error) {
            dispatch(
              setReachabilityTestResult({
                reachabilityTest,
                result: {
                  isLoading: false,
                  isSuccessful: false,
                  isDirty: false,
                },
              }),
            );

            trackError(error, {
              label: Errors.UNREACHABLE_THIRD_PARTY_SERVICE,
              info: reachabilityTest,
            });
          }
        })();
      }
    });
  }, [reachabilityResult, dispatch]);

  return null;
};
